import {Skeleton} from 'shared/ui/Skeleton';
import React from 'react';

export const SkeletonBlock = () => (
  <Skeleton width={'100%'} height={82}>
    <rect width={'100%'} height={80} rx={16} ry={16} />
  </Skeleton>
);
